import { Address } from '@/dataV3/Common/Address'
import { User } from '@/dataV3/User/User'
import { APIRoute } from '@/modules/utils'
import { PureObject } from 'emt-library'

export type Body = {
  phone?: string
  address?: PureObject<Address>
}

export type Response = User

export const Route: APIRoute = {
  method: 'PUT',
  path: '/acquisition/members/petowners/contact',
}
